/*
  OWN WISHLIST — storefront side (2026-11-04). Replaces Wishlist King (Swish).

  Loaded only where the own wishlist is ON (theme setting "Use LL Medico wishlist", or a customer
  tagged `wishlist-beta` for the preview) — see layout/theme.liquid.

  The list lives in the worker's D1 table, reached through Shopify's app proxy:
    GET  /apps/llm-account/wishlist                 -> { signedIn, items: [{ p, v, at }] }
    POST /apps/llm-account/wishlist {op, productId, variantId}  (op = add | remove)
  The proxy signs every request with the logged-in customer's id, so nothing here names a customer.

  Hearts are any element with [data-llm-wish] and data-product-id (optional data-variant-id). They
  are wired by ONE delegated click handler, so hearts rendered later (search results, the saved row,
  quick views) work with no extra code. Their pressed state is set from the list on load and after
  every change.

  Guests: the owner chose sign-in-to-save (10-28). A guest's heart goes to the sign-in route with a
  return_to of this page. ⛔ Never /pages/login — that is the Descope flow host, not a sign-in page.
  The tapped product is remembered first (localStorage 'llm-wl-pending', 30 minutes), and the first
  signed-in page load saves it — owner 2026-11-04: signing in from the heart came back to an EMPTY
  heart, so the tap that started it all had been lost.

  window.LLMWishlist: { ready (Promise), has(productId), ids(), items(), toggle(productId, variantId) }
  Fires `llm:wishlist:change` on document with detail { items } after every change.
*/
(function () {
  if (window.LLMWishlist) return;

  var cfg = window.__llmWishlistCfg || {};
  var URL_ = '/apps/llm-account/wishlist';
  var CACHE = cfg.customerId ? 'llm-wl-' + cfg.customerId : null;
  var state = [];          // [{ p, v, at }]
  var pending = {};        // productId -> true while a request is in flight

  function read() { try { return JSON.parse(localStorage.getItem(CACHE) || 'null'); } catch (e) { return null; } }
  function write(items) { try { localStorage.setItem(CACHE, JSON.stringify(items)); } catch (e) {} }

  function has(pid) { pid = String(pid); return state.some(function (i) { return String(i.p) === pid; }); }

  function paint(root) {
    (root || document).querySelectorAll('[data-llm-wish]').forEach(function (b) {
      var on = has(b.getAttribute('data-product-id'));
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      // `title` = the browser's own hover label (owner 2026-11-04); it says what a click will do.
      var label = on ? 'Remove from saved items' : 'Save this product';
      b.setAttribute('aria-label', label);
      b.setAttribute('title', label);
      b.classList.toggle('is-saved', on);
    });
  }

  function set(items) {
    state = Array.isArray(items) ? items : [];
    if (CACHE) write(state);
    paint();
    document.dispatchEvent(new CustomEvent('llm:wishlist:change', { detail: { items: state.slice() } }));
  }

  function request(method, body) {
    return fetch(URL_, {
      method: method,
      credentials: 'same-origin',
      headers: body ? { 'Content-Type': 'application/json', 'Accept': 'application/json' } : { 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); });
  }

  // Paint from last visit's copy immediately, then refresh from the server.
  if (CACHE) { var c = read(); if (c) { state = c; } }
  var ready = cfg.customerId
    ? request('GET').then(function (r) { if (r.json && Array.isArray(r.json.items)) set(r.json.items); return state; })
        .catch(function () { return state; })
    : Promise.resolve([]);

  var PENDING = 'llm-wl-pending';
  function signIn(pid, vid) {
    if (pid) { try { localStorage.setItem(PENDING, JSON.stringify({ p: String(pid), v: String(vid || 0), t: Date.now() })); } catch (e) {} }
    var back = window.location.pathname + window.location.search;
    window.location.href = (cfg.loginUrl || '/customer_authentication/login') +
      ((cfg.loginUrl || '').indexOf('?') >= 0 ? '&' : '?') + 'return_to=' + encodeURIComponent(back);
  }

  function toggle(pid, vid) {
    pid = String(pid);
    if (!cfg.customerId) { signIn(pid, vid); return Promise.resolve(false); }
    if (pending[pid]) return Promise.resolve(has(pid));
    var adding = !has(pid);
    pending[pid] = true;

    // Optimistic: flip now, reconcile with the server's list when it answers.
    var before = state.slice();
    if (adding) set([{ p: Number(pid), v: Number(vid) || 0, at: new Date().toISOString() }].concat(state));
    else set(state.filter(function (i) { return String(i.p) !== pid; }));

    return request('POST', { op: adding ? 'add' : 'remove', productId: pid, variantId: vid || 0 })
      .then(function (r) {
        if (r.json && Array.isArray(r.json.items)) set(r.json.items);
        else if (!r.ok) set(before);
        if (r.json && r.json.signedIn === false) signIn(pid, vid);
        return has(pid);
      })
      .catch(function () { set(before); return has(pid); })
      .then(function (v) { delete pending[pid]; return v; });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-llm-wish]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(b.getAttribute('data-product-id'), b.getAttribute('data-variant-id'));
  }, true);

  // Hearts that arrive after load (search results, quick views, the saved row) get painted too.
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      for (var j = 0; j < muts[i].addedNodes.length; j++) {
        var n = muts[i].addedNodes[j];
        if (n.nodeType === 1 && (n.matches('[data-llm-wish]') || n.querySelector('[data-llm-wish]'))) { paint(n.parentNode || n); }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Back from sign-in: save the item the guest tapped (once, and only if it is not already saved).
  if (cfg.customerId) {
    ready.then(function () {
      var pend = null;
      try { pend = JSON.parse(localStorage.getItem(PENDING) || 'null'); localStorage.removeItem(PENDING); } catch (e) {}
      if (pend && pend.p && Date.now() - (pend.t || 0) < 30 * 60 * 1000 && !has(pend.p)) toggle(pend.p, pend.v);
    });
  }

  window.LLMWishlist = {
    ready: ready,
    has: has,
    ids: function () { var seen = {}, out = []; state.forEach(function (i) { if (!seen[i.p]) { seen[i.p] = 1; out.push(i.p); } }); return out; },
    items: function () { return state.slice(); },
    toggle: toggle
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { paint(); });
  else paint();
})();
